<template>
    <p class="subscription-text-md">
        {{ t("payments.subscription_next_payment") }}:
        <span class="accent-date">{{ formatdate(date) }}</span>
    </p>
</template>

<script>
export default {
    props: {
        date: {
            type: String,
            default: ""
        }
    },
    name: "PublicOfferOrderNextPayment"
}
</script>

<style scoped lang="sass">

</style>
